import { Injectable } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { Subject } from 'rxjs';
import { Endpoints } from 'src/app/services/http/http-wrapper/endpoint';
import { HttpWrapperService } from 'src/app/services/http/http-wrapper/http-wrapper.service';
import { Session_Storage_keys, Storage_Keys } from 'src/app/services/storage/storage.keys';
import { StorageService } from 'src/app/services/storage/storage.service';
import { SessionStorageService } from '../storage/session-storage.service';

@Injectable({
  providedIn: 'root'
})

export class CommonService {
  priceIncrementModalEvent: Subject<ModalFor> = new Subject<ModalFor>();
  versionRefresh: Subject<boolean> = new Subject<boolean>();
  userDetails: any;
  nextRoute: string;
  catalogVersion: any;
  isDisabled: boolean = false;

  constructor(
    private toast: ToastrService,
    private spinner: NgxSpinnerService,
    private httpWrapper: HttpWrapperService,
    private storage: StorageService,
    private sessionStorage: SessionStorageService
  ) { }

  presentSpinner() {
    this.spinner.show();
  }

  dismissSpinner() {
    this.spinner.hide();
  }

  showSuccessToastMsg(title?: string, message?: string) {
    this.toast.success(message, title, {
      timeOut: 2000
    });
  }

  showErrorToastMsg(title?: string, message?: string) {
    this.toast.error(message, title, {
      timeOut: 5000
    });
  }

  calculateEntries(list: Array<any>, current_page: number, limit: number, totalResult: number): Entries {
    if (list.length === totalResult) {
      let pages = {
        1: []
      };
      let arr = [];
      let page = 1;
      for (let i = 0; i < list.length; i++) {
        arr.push(list[i]);
        if (arr.length == limit) {
          pages[page] = arr;
          page += 1;
          arr = [];
        } else {
          if (i == list.length - 1) {
            pages[page] = arr;
            page += 1;
            arr = [];
          }
        }
      }
      list = pages[current_page];
    }
    return {
      from: limit * (current_page - 1) + 0 + 1,
      to: limit * (current_page - 1) + (list.length - 1) + 1,
      total: totalResult,
    };
  }

  numberOnly(event): boolean {
    var charCode = (event.which) ? event.which : event.keyCode;
    if (charCode != 46 && charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  loadUserDetail() {
    let savedData = this.storage.getSavedData();
    if (savedData && savedData[Storage_Keys.AdminData]) {
      return this.userDetails = savedData[Storage_Keys.AdminData];
    } else {
      return this.userDetails = null;
    }
  }

  // loadVersions() {
  //   let savedData = this.sessionStorage.getSavedData();
  //   if (savedData && savedData[Session_Storage_keys.catalogVersion]) {
  //     this.catalogVersion = savedData[Session_Storage_keys.catalogVersion];
  //   } else {
  //     this.catalogVersion = null;
  //   }
  //   this.isDisabled = this.catalogVersion.status === 'Expired' || this.catalogVersion.status === 'Active';
  //   return this.catalogVersion;
  // }

  getChoices(version_Id) {
    return new Promise((resolve, reject) => {
      this.httpWrapper.get(Endpoints.common.choices(version_Id)).subscribe(
        (res) => {
          resolve(res);
        },
        (error) => {
          reject(error);
        }
      );
    });
  }

  getFields(product_id, version_Id, forPrice?: boolean, forDisplay?: boolean) {
    return this.httpWrapper.get(Endpoints.common.fields(product_id, version_Id) + `${forPrice ? '&forPrice=' + forPrice : ''}` + `${forDisplay ? '&forDisplay=' + forDisplay : ''}`).map(
      (res) => {
        if (res) {
          return res;
        }
      }).toPromise()
      .catch(
        (error) => {
          return error;
        }
      );
  }

  getProducts() {
    return this.httpWrapper.get(Endpoints.common.products).map(
      (res) => {
        if (res) {
          return res;
        }
      }
    ).toPromise()
      .catch(
        (error) => {
          return error;
        }
      );
  }

  getRegions() {
    return new Promise((resolve, reject) => {
      this.httpWrapper.get(Endpoints.common.regions).subscribe(
        (res) => {
          resolve(res);
        },
        (error) => {
          reject(error);
        }
      );
    });
  }

  getPackages() {
    return new Promise((resolve, reject) => {
      this.httpWrapper.get(Endpoints.common.packages).subscribe(
        (res) => {
          resolve(res);
        },
        (error) => {
          reject(error);
        }
      );
    });
  }

  getFieldsCheck(versionId) {
    return new Promise((resolve, reject) => {
      this.httpWrapper.get(Endpoints.fieldsCheck(versionId)).subscribe(
        (res) => {
          resolve(res);
        },
        (error) => {
          reject(error);
        }
      );
    });
  }

}

export interface Entries {
  from: any;
  to: any;
  total: any;
}

export type ModalFor = "basePrice" | "optionPrice" | "additionalFee";
